import * as React from "react";
import { Textarea } from "@fluentui/react-components";
import Style from "./Textarea.module.scss";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

export const TextArea = (props) => {
  const {
    label,
    onChange,
    placeholder,
    value,
    textreawd,
    textAreaFieldSize,
    readonly,
    handleBlur,
    handleKeyDown,
    ref,
    loading = false,
  } = props;
  const handleChange = (data) => {
    if (label === "Additional Address") {
      if (data.target.value.length <= 255) {
        onChange(data.target.value);
      }
    } else {
      onChange(data.target.value);
    }
  };

  return (
    <div className={`${textreawd} textArea_container`}>
      {label && <label className="textArea_label">{label}</label>}
      <div className="textArea_wrapper">
        {loading ? (
          <Skeleton height={120} baseColor="#e0e0e0" highlightColor="#ECE7FD" />
        ) : (
          <>
            <Textarea
              ref={ref}
              value={value}
              className={`${textAreaFieldSize} textArea textArea_Field `}
              placeholder={placeholder}
              onChange={(data) => handleChange(data)}
              disabled={readonly}
              onBlur={handleBlur}
              onKeyDown={handleKeyDown}
            />
            {label === "Additional Address" && (
              <span
                className="d-flex justify-content-end"
                style={{ fontSize: "11px" }}
              >{`${value?.length || 0}/255`}</span>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default TextArea;
